/* Versand & Lieferung — GSAP entry animations */
(function () {
  function init() {
    if (typeof window.gsap === 'undefined') return setTimeout(init, 60);
    if (typeof window.ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(window.ScrollTrigger);
    }

    document.querySelectorAll('.versand-page').forEach((root) => {
      // Hero
      const heroEls = [
        root.querySelector('.versand-hero__label'),
        root.querySelector('.versand-hero__heading'),
        root.querySelector('.versand-hero__rule'),
        root.querySelector('.versand-hero__subtext'),
        root.querySelector('.versand-hero__aside'),
      ].filter(Boolean);

      gsap.to(heroEls, {
        opacity: 1,
        y: 0,
        duration: 1.1,
        ease: 'power3.out',
        stagger: 0.12,
        delay: 0.15,
      });
      gsap.from(heroEls, { y: 24, duration: 0.01 });

      // Section heads + items reveal
      const reveal = (selector, opts = {}) => {
        root.querySelectorAll(selector).forEach((el) => {
          gsap.fromTo(
            el,
            { opacity: 0, y: 28 },
            {
              opacity: 1,
              y: 0,
              duration: 0.9,
              ease: 'power2.out',
              ...opts,
              scrollTrigger: {
                trigger: el,
                start: 'top 88%',
                once: true,
              },
            }
          );
        });
      };

      reveal('.versand-options__head > *', { stagger: 0.08 });
      reveal('.versand-option', { stagger: 0.1 });
      reveal('.versand-process__head > *', { stagger: 0.08 });
      reveal('.versand-process__step', { stagger: 0.12 });
      reveal('.versand-info__head > *', { stagger: 0.08 });
      reveal('.versand-info__item', { stagger: 0.08 });
      reveal('.versand-closing__inner > *', { stagger: 0.1 });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
